export default "__VITE_ASSET__S119IqkD__"